import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import React, { useContext, useMemo } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Form } from '@applyboard/ui-components';
import { useOnboardingFormControllerContext } from "../../../controller/OnboardingFormController";
import { Content } from "./Content";
import EducationDataProvider from "../../../CEF/Providers/Education/EducationDataProvider";
import { storeProgramLevelFamilyValue, getStoredProgramLevelFamily, deleteStoredProgramLevelFamilies } from "../../storage/ProgramLevelFamilies/localStorage";
import { LoadingOverlay } from "../../../../ab-common-legacy/LoadingOverlay";
import { useDeleteStudentPreferences, useEditStudentPreferences, useEducationLevelFamilyTypes, useStudentPreferences } from "../../../../data";
import { useAppContext } from "../../../CEF/Providers";
import { FormStateContext } from "../../../FormStateProvider";
export var ProgramLevelFamiliesPage = function ProgramLevelFamiliesPage() {
  var _useOnboardingFormCon = useOnboardingFormControllerContext(),
    handlePassed = _useOnboardingFormCon.handlePassed,
    handleSkipped = _useOnboardingFormCon.handleSkipped,
    handleError = _useOnboardingFormCon.handleError;
  var _useContext = useContext(FormStateContext),
    onShowError = _useContext.onShowError;
  var _useAppContext = useAppContext(),
    userId = _useAppContext.userId;
  userId = userId ? userId.toString() : null;
  var _useEducationLevelFam = useEducationLevelFamilyTypes(),
    educationLevelFamilyTypes = _useEducationLevelFam.educationLevelFamilyTypes,
    isLoadingEducationLevelFamilyTypes = _useEducationLevelFam.isLoadingEducationLevelFamilyTypes;
  var _useStudentPreference = useStudentPreferences(userId, {
      enabled: Boolean(userId)
    }),
    studentPreferences = _useStudentPreference.studentPreferences,
    isLoadingStudentPreferences = _useStudentPreference.isLoadingStudentPreferences;
  var _useEditStudentPrefer = useEditStudentPreferences(userId, 'program_level_families'),
    editStudentPreferences = _useEditStudentPrefer.editStudentPreferences;
  var _useDeleteStudentPref = useDeleteStudentPreferences(userId, 'program_level_families'),
    deleteStudentPreferences = _useDeleteStudentPref.deleteStudentPreferences;
  var options = useMemo(function () {
    if (!isLoadingEducationLevelFamilyTypes && educationLevelFamilyTypes.length > 0) {
      var educationLevelOptions = educationLevelFamilyTypes.map(function (data) {
        return {
          label: data.label,
          name: data.id
        };
      });
      return educationLevelOptions;
    }
    return [];
  }, [isLoadingEducationLevelFamilyTypes, educationLevelFamilyTypes]);
  if (options.length === 0 || isLoadingStudentPreferences && userId) {
    return /*#__PURE__*/React.createElement(LoadingOverlay, {
      "aria-label": "Loading"
    });
  }
  var signedInSubmit = function signedInSubmit(selectedLevels) {
    var data = {
      values: selectedLevels,
      type: 'program_level_families'
    };
    editStudentPreferences(data, {
      onSuccess: function onSuccess() {
        var selectedLevelNames = selectedLevels.map(function (level) {
          var _options$find$label, _options$find;
          return (_options$find$label = (_options$find = options.find(function (option) {
            return option.name === level;
          })) === null || _options$find === void 0 ? void 0 : _options$find.label) !== null && _options$find$label !== void 0 ? _options$find$label : level;
        });
        handlePassed({
          values: selectedLevelNames
        });
      },
      onError: function onError() {
        onShowError();
        handleError();
      }
    });
  };
  var skipLevelsSubmit = function skipLevelsSubmit() {
    if (userId) {
      deleteStudentPreferences(undefined, {
        onSuccess: function onSuccess() {
          handleSkipped();
        },
        onError: function onError() {
          onShowError();
          handleError();
        }
      });
    } else {
      deleteStoredProgramLevelFamilies();
      handleSkipped();
    }
  };
  var levelsSubmit = function levelsSubmit(data) {
    var programLevelFamilies = data.programLevelFamilies;
    if (userId) {
      signedInSubmit(programLevelFamilies);
    } else {
      storeProgramLevelFamilyValue(programLevelFamilies);
      var selectedLevelNames = programLevelFamilies.map(function (level) {
        var _options$find$label2, _options$find2;
        return (_options$find$label2 = (_options$find2 = options.find(function (option) {
          return option.name === level;
        })) === null || _options$find2 === void 0 ? void 0 : _options$find2.label) !== null && _options$find$label2 !== void 0 ? _options$find$label2 : level;
      });
      handlePassed({
        values: selectedLevelNames
      });
    }
  };
  var defaultValues = {
    programLevelFamilies: userId ? studentPreferences.programLevelFamily : getStoredProgramLevelFamily()
  };
  return /*#__PURE__*/React.createElement(EducationDataProvider, null, /*#__PURE__*/React.createElement(Form, {
    onSubmit: function onSubmit(values) {
      return levelsSubmit(values);
    },
    defaultValues: defaultValues,
    onSubmitError: handleError
  }, /*#__PURE__*/React.createElement(Content, {
    options: options,
    skipLevelsSubmit: skipLevelsSubmit
  })));
};